import React, { useEffect, useState } from 'react'
import PostByAgg from '../../utils/axios';

const channelLogos = {
    "JOOX": "https://designer.tencent.co.th/logo/dw/JOOX_icon_vertical_full_color.png",
    "Spotify": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Spotify_logo_without_text.svg/2048px-Spotify_logo_without_text.svg.png",
    "Youtube Musik": "https://static.vecteezy.com/system/resources/previews/017/395/384/non_2x/youtube-music-icon-free-png.png",
    "Langit Musik": "https://www.langitmusik.co.id/favicon.ico", 
};

const TopThreeChannel = () => {
    const [channelData, setChannelData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchChannelData();
    }, []);

    const fetchChannelData = () => {
        setLoading(true);
        PostByAgg({
            url: 'song/v1/track/count-song-by-channel',
            body: {
                music_label_code: 'ML2411257492279'
            },
            onResponse: (res) => {
                if (Array.isArray(res.data)) {
                    setChannelData(res.data);
                } else if (Array.isArray(res?.data?.data)) {
                    setChannelData(res.data.data);
                } else {
                    setChannelData([]);
                }
                setLoading(false);
            },
            onError: () => {
                setChannelData([]);
                setLoading(false);
            }
        });
    };

    return (
        <div className="col-12">
            <h6 className="mb-16">Top 3 Channel</h6>
            <div className="row gy-4">
                {loading ? (
                    <div className="text-center w-100">Loading...</div>
                ) : (
                    channelData.slice(0, 3).map((item, index) => (
                        <div key={index} className="col-lg-4 col-sm-6">
                            <div className={`card px-24 py-16 shadow-none radius-12 border h-100 bg-gradient-start-${index + 2}`}>
                                <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1">
                                        <div className="d-flex align-items-center flex-wrap gap-16">
                                            <span className="mb-0 w-60-px h-60-px flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                                <img
                                                    src={channelLogos[item.channel] || 'https://via.placeholder.com/40'}
                                                    alt={`${item.channel} Logo`}
                                                    className="icon w-100 h-100 object-fit-cover rounded-circle"
                                                />
                                            </span>
                                            <div className="flex-grow-1">
                                                <h6 className="fw-semibold mb-0">{item.song_count} Songs</h6>
                                                <span className="fw-medium text-secondary-light text-md">
                                                    {item.channel}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
                {!loading && channelData.length === 0 && (
                    <div className="text-center w-100">No data available</div>
                )}
            </div>
        </div>
    );
};

export default TopThreeChannel;
